import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from '@/shared/components/notifications';
import { CreateAlertFormValues } from '../types';
import { createAlert } from '../services/alertsService';
import { AlertForm } from './AlertForm';

const defaultAvailableTo = new Date();
defaultAvailableTo.setFullYear(defaultAvailableTo.getFullYear() + 1);

const emptyDefaults: CreateAlertFormValues = {
  address: '',
  latitude: undefined,
  longitude: undefined,
  distanceEnabled: true,
  maxDistance: 25,
  materialId: '',
  materialCategory: '',
  materialSubcategory: '',
  condition: '',
  availabilityEnabled: false,
  availableFrom: null,
  availableTo: defaultAvailableTo,
};

export function CreateAlertPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showSuccess, showError } = useSnackbar();

  const handleSubmit = async (data: CreateAlertFormValues) => {
    try {
      await createAlert(data);
      showSuccess(t('alerts.create.successMessage'));
      navigate('/alerts');
    } catch (error) {
      console.error('Error creating alert:', error);
      showError(t('alerts.create.errorMessage'));
    }
  };

  return (
    <AlertForm
      defaultValues={emptyDefaults}
      onSubmit={handleSubmit}
      title={t('alerts.create.title')}
      submitLabel={t('alerts.create.submitButton')}
      submittingLabel={t('alerts.create.submitting')}
      testIdPrefix="create-alert"
    />
  );
}
